import { useEffect } from "react";

type FullscreenProgressProps = {
  visible: boolean;
  message?: string;
};

export function FullscreenProgress({ visible, message }: FullscreenProgressProps) {
  useEffect(() => {
    if (!visible) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="fullscreen-progress" role="progressbar" aria-label={message || "Yükleniyor"}>
      <div className="fullscreen-progress-content">
        <span className="fullscreen-progress-indicator" aria-hidden="true" />
        <strong>{message || "İşlem sürüyor…"}</strong>
      </div>
    </div>
  );
}
